import type { CustomerAuthFieldUiHelpers } from './types'
import { CustomerAuthInputField } from './CustomerAuthInputField'

type LoginCredentialsPanelProps = {
  identifierLabel: string
  identifierPlaceholder: string
  passwordLabel: string
  passwordPlaceholder: string
  passwordShowLabel: string
  passwordHideLabel: string
  identifier: string
  password: string
  onIdentifierChange: (value: string) => void
  onPasswordChange: (value: string) => void
  forgotPasswordLabel: string
  onForgotPassword: () => void
  ui: CustomerAuthFieldUiHelpers
}

export const LoginCredentialsPanel = ({
  identifierLabel,
  identifierPlaceholder,
  passwordLabel,
  passwordPlaceholder,
  passwordShowLabel,
  passwordHideLabel,
  identifier,
  password,
  onIdentifierChange,
  onPasswordChange,
  forgotPasswordLabel,
  onForgotPassword,
  ui,
}: LoginCredentialsPanelProps) => {
  const forgotPasswordAction = (
    <button
      type="button"
      onClick={() => {
        onForgotPassword()
      }}
      className="inline-flex items-center text-xs font-semibold text-(--color-focus-ring) underline decoration-[color-mix(in_srgb,var(--color-focus-ring)_35%,transparent)] underline-offset-4 transition-colors duration-150 hover:text-(--color-text-primary)"
    >
      {forgotPasswordLabel}
    </button>
  )

  return (
    <div className="grid gap-3.5">
      <CustomerAuthInputField
        field="email"
        label={identifierLabel}
        type="text"
        value={identifier}
        onChange={onIdentifierChange}
        placeholder={identifierPlaceholder}
        autoComplete="username"
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        inputMode="email"
        required
        ui={ui}
      />
      <CustomerAuthInputField
        field="password"
        label={passwordLabel}
        type="password"
        value={password}
        onChange={onPasswordChange}
        placeholder={passwordPlaceholder}
        autoComplete="current-password"
        required
        minLength={8}
        allowPasswordToggle
        showPasswordLabel={passwordShowLabel}
        hidePasswordLabel={passwordHideLabel}
        labelAction={forgotPasswordAction}
        ui={ui}
      />
    </div>
  )
}
